import { render, staticRenderFns } from "./AppEditRewards.vue?vue&type=template&id=12a4040d&scoped=true"
import script from "./AppEditRewards.vue?vue&type=script&lang=js"
export * from "./AppEditRewards.vue?vue&type=script&lang=js"
import style0 from "./AppEditRewards.vue?vue&type=style&index=0&id=12a4040d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a4040d",
  null
  
)

export default component.exports